import get from 'lodash/get';
import { text } from '../text';

export const getTranslation = (key, lang) => {
    return get(text, `${lang}.${key}`);
};
